import React, { useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'

interface ITooltipProps {
  children: React.ReactNode | string
  content: string
  block?: boolean
}

const Tooltip: React.FC<ITooltipProps> = ({ children, content, block }) => {
  const [isHovering, setIsHovering] = useState<boolean>(false)

  return (
    <div className={`tooltip-wrapper ${block ? 'block' : ''}`}>
      <AnimatePresence>
        {isHovering && (
          <motion.div
            transition={{ ease: 'easeOut' }}
            initial={{ opacity: 0, scale: 0.9, x: '-50%' }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            className='tooltip'
          >
            {content}
          </motion.div>
        )}
      </AnimatePresence>

      <div
        onMouseOver={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
        onFocus={() => setIsHovering(true)}
        onBlur={() => setIsHovering(false)}
      >
        {children}
      </div>
    </div>
  )
}

export default Tooltip
